import styled from "styled-components";
import { Container, Card, Button, Form, ButtonGroup } from "react-bootstrap";

export const StyledContainer = styled(Container)`
  padding: 2rem 1rem;
  min-height: 100vh;
  width: 100%;
  background: #fff;
`;

export const ApiHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding: 0.5rem 0;
`;

export const Title = styled.h1`
  font-size: 1.75rem;
  font-weight: 600;
  margin-bottom: 0;
  color: #333;
`;

export const ApiCard = styled(Card)`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
`;

export const ApiCardHeader = styled(Card.Header)`
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  padding: 1rem;
`;

export const ApiCardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
`;

export const ApiCardPath = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
`;

export const MethodBadge = styled.span`
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  font-family: monospace;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: white;
  background-color: ${props => {
    switch (props.method?.toLowerCase()) {
      case "get":
        return "#61affe";
      case "post":
        return "#49cc90";
      case "put":
        return "#fca130";
      case "delete":
        return "#f93e3e";
      case "patch":
        return "#50e3c2";
      default:
        return "#6c757d";
    }
  }};
`;

export const EndpointPath = styled.span`
  font-family: "Roboto Mono", monospace;
  color: #444;
  font-size: 0.85rem;
  word-wrap: break-word;
  word-break: break-all;
  display: inline-block;
  max-width: 100%;
  overflow-wrap: break-word;
  line-height: 1.4;
  padding: 0.25rem 0;
`;

export const CategoryTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 500;
  color: #333;
  margin: 1.5rem 0 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #f0f0f0;
`;

export const ResponseContainer = styled.div`
  background-color: #f8f9fa;
  color: #333;
  padding: 1rem;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  font-family: "Roboto Mono", monospace;
  font-size: 0.85rem;
  max-height: 400px;
  overflow-y: auto;
  margin-top: 1rem;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const ParamInput = styled(Form.Control)`
  font-family: "Roboto Mono", monospace;
  font-size: 0.85rem;
  margin-bottom: 0.75rem;
  border-color: #e0e0e0;

  &:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`;

export const StickyResponsePanel = styled(Card)`
  position: sticky;
  top: 20px;
  z-index: 100;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

export const HideButton = styled(Button)`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 1000;
  border-radius: 4px;
  width: 28px;
  height: 28px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid #e0e0e0;
  color: #666;

  &:hover {
    background: #f8f9fa;
    border-color: #d0d0d0;
    color: #333;
  }
`;

export const GroupBySwitcher = styled(ButtonGroup)`
  margin-bottom: 1.5rem;

  .btn {
    font-size: 0.85rem;
    padding: 0.375rem 0.75rem;
    border-color: #e0e0e0;

    &:not(:disabled):not(.disabled).active {
      background-color: #007bff;
      border-color: #007bff;
      color: white;
    }

    &:focus {
      box-shadow: none;
    }
  }
`;

export const StatusCodeBadge = styled.span`
  padding: 0.15rem 0.4rem;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  font-family: monospace;
  margin-left: 0.5rem;
  color: white;
  background-color: ${props => {
    return props.statusCode >= 200 && props.statusCode < 300 ? "#49cc90" : "#f93e3e";
  }};
`;
